/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-tabs */
/* eslint-disable spaced-comment */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { TiPencil } from "react-icons/ti";
import { HiOutlineDocumentDownload } from "react-icons/hi";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import { GoCheck } from "react-icons/go";
import ReactTooltip from "react-tooltip";
import { useQuery } from "react-query";
import { MdOutlineCancel } from "react-icons/md";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import favicon from "../../../Assets/favicon.ico";
import {
  addToMyProducts,
  addToMyProject,
  addToMyCart,
  exportXls,
  getSavedConfigurationById,
  logEvent,
  saveConfiguration,
  updateConfigurationApi
} from "../../../utils/api/api";
import {
  setConfigurationIdToShare,
  setReFetchConfigurations,
  setShowEmailPopup,
  showSnackbar,
  setShowDeleteConfirmationPopup,
  selectPartnerPreferences,
  setConfigurationTypeToShare,
  setConfiguration
} from "../../../../Retrofit/store/slices/retrofit";
import t from "../../../utils/translation/translator";
import MsxIcons from "../../Icons/MsxIcons/MsxIcons";
import isFilenameValid from "../../../../Retrofit/utils/filenameValidator";
import { selectEventsData, setConfigurationType, setFullScreen } from "../../../store/slices/common";
import { buildAddToCartDataLayerEvent, logDataLayerEvent } from "../../../utils/dataLayerAnalytics/dataLayerAnalytics";
import { gatherMc12ProductsForBOM } from "../../../../Mc12/utils/func.utils";
import { gatherCartesianProductsForBOM } from "../../../../Cartesian/utils/func.utils";
import { gatherRetrofitProductsForBOM } from "../../../../Retrofit/utils/func.util";
import { setMc12Configuration } from "../../../../Mc12/store/slices/mc12";
import { setCartesianConfiguration } from "../../../../Cartesian/store/slices/cartesian";
import { setIntegratedDrivesConfiguration } from "../../../../IntegratedDrives/store/slices/integrated_drives";
import { isUnifiedCheckoutAvailable, isWorkspaceAvailable } from "../../../utils/func.util";

const SavedConfigCard = ({
  id,
  title,
  date,
  country,
  status,
  numberOfAxes,
  getConfIdToDelete,
  configurationType,
  kinematicsType,
  idLabel,
  configuration,
  ...props
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showEditName, setShowEditName] = useState(false);
  const [newTitle, setNewTitle] = useState(title);
  const dispatch = useDispatch();

  const partnerPreferences = useSelector(selectPartnerPreferences);
  const disabled = status === "OBSOLETE" || status === "CANCELLED";

  const statusStyle = {
    IN_PROGRESS: "decoration-yellow-300",
    FINISHED: "",
    CANCELLED: "underline decoration-red-300",
    OBSOLETE: "underline decoration-red-300"
  };

  const eventsData = useSelector(selectEventsData);

  const locale = window.msizerConfiguration?.locale || "en-WW";
  const splitLocale = locale.split("-");
  const countryScope = splitLocale[1];

  const {
    // eslint-disable-next-line no-unused-vars
    refetch: execDeleteConfiguration,
    isFetching: isFetchingDeleteConfiguration,
    isLoading: isLoadingDeleteConfiguration
  } = useQuery(
    "DELETE : Get saved configuration by ID then change status then update it",
    async () => {
      try {
        logEvent(eventsData.locale, eventsData.types.deleteConf, eventsData.tags.none, id);
        const fetchedConf = await getSavedConfigurationById({
          id,
          configurationType
        });
        fetchedConf.configuration.configData.configStatus = "OBSOLETE";
        const updatedConf = await updateConfigurationApi(id, fetchedConf.configuration.configData);
        dispatch(setReFetchConfigurations());
        setShowMenu(false);
        return updatedConf;
      } catch (error) {
        console.error("ERR", error.response?.status);
        setShowMenu(false);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execRenameConfiguration,
    isFetching: isFetchingRenameConfiguration,
    isLoading: isLoadingRenameConfiguration
  } = useQuery(
    "RENAME : Get saved configuration by ID then change name then update it",
    async () => {
      try {
        logEvent(eventsData.locale, eventsData.types.rename, eventsData.tags.startPage, id);
        const fetchedConf = await getSavedConfigurationById({
          id,
          configurationType
        });
        fetchedConf.configuration.configData.configName = newTitle;
        const updatedConf = await updateConfigurationApi(id, fetchedConf.configuration.configData);
        setShowEditName(false);
        dispatch(setReFetchConfigurations());
        return updatedConf;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );
  const {
    refetch: execDuplicateConfiguration
    // isFetching: isFetchingDuplicateConfiguration,
    // isLoading: isLoadingDuplicateConfiguration
  } = useQuery(
    "DUPLICATE : Get saved configuration by ID then change status ans step and name then save it then load it",
    async () => {
      try {
        logEvent(eventsData.locale, eventsData.types.duplicateConf, eventsData.tags.savedConfigCard, id);
        const fetchedConf = await getSavedConfigurationById({
          id,
          configurationType
        });
        fetchedConf.configuration.configData.configName = `${fetchedConf.configuration.configData.configName} copy`;
        fetchedConf.configuration.configData.configStatus = "IN_PROGRESS";
        fetchedConf.configuration.configData.currentStepId = 2; // first step in all steppers
        fetchedConf.configuration.configData.country = window.msizerConfiguration.locale.split("-")[1] || "WW";
        const duplicatedConf = await saveConfiguration(fetchedConf.configuration.configData);
        // load the new configuration
        switch (configurationType) {
          case "RETROFIT":
            dispatch(setConfiguration(duplicatedConf.savedConfigData));
            dispatch(setConfigurationType(configurationType));
            break;
          case "MC12":
            dispatch(setMc12Configuration(duplicatedConf.savedConfigData));
            dispatch(setConfigurationType(configurationType));
            break;
          case "CARTESIAN":
            dispatch(setCartesianConfiguration(duplicatedConf.savedConfigData));
            dispatch(setConfigurationType(configurationType));
            break;
          case "INTEGRATED_DRIVES":
            dispatch(setIntegratedDrivesConfiguration(duplicatedConf.savedConfigData));
            dispatch(setConfigurationType(configurationType));
            break;
          default:
            throw new Error(`Invalid configuration type: ${configurationType}`);
        }
        dispatch(showSnackbar({ id: "COPY_CONFIG" }));
        dispatch(setFullScreen(true));
        return duplicatedConf.savedConfigData;
      } catch (error) {
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execExportXls,
    isLoading: isLoadingExport,
    isFetching: isFetchingExport
  } = useQuery(
    "Export BOM in XLS",
    async () => {
      try {
        logEvent(eventsData.locale, eventsData.types.export, eventsData.tags.startPage, id);
        const exportUri = await exportXls(id, configurationType);
        setShowMenu(false);
        return exportUri;
      } catch (error) {
        setShowMenu(false);
        console.error(error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execAddToMyProducts,
    isFetching: isFetchingAddToMyProducts,
    isLoading: isLoadingAddToMyProducts
  } = useQuery(
    "Add to my products",
    async () => {
      try {
        logEvent(eventsData.locale, eventsData.types.addToFavourites, eventsData.tags.startPage, id);
        const configurationFromApi = await getSavedConfigurationById({
          id,
          configurationType
        });
        const eventName = "ADD_TO_MY_PRODUCTS";

        var products = [];
        switch (configurationFromApi?.configuration?.configData?.configurationType) {
          case "MC12":
            const { track } = configurationFromApi?.configuration?.configData;
            products = gatherMc12ProductsForBOM(track);
            break;
          case "CARTESIAN":
            products = await gatherCartesianProductsForBOM(configurationFromApi?.configuration?.configId);
            break;
          case "INTEGRATED_DRIVES":
            products = [];
            break;
          default:
            const { axes } = configurationFromApi?.configuration?.configData;
            products = gatherRetrofitProductsForBOM(axes);
        }

        logDataLayerEvent(
          buildAddToCartDataLayerEvent(
            {
              id: configurationFromApi?.configuration?.configId,
              name: configurationFromApi?.configuration?.configData?.configName,
              step: "start"
            },
            eventName,
            products
          )
        );
        const res = await addToMyProducts(configurationFromApi?.configuration);
        if (partnerPreferences === null) {
          dispatch(showSnackbar({ id: "BILL_ADDED" }));
        } else {
          dispatch(showSnackbar({ id: "BILL_ADDED", hideCTA: true }));
        }
        return res;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, id);
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execAddToProject,
    isFetching: isFetchingAddToProject,
    isLoading: isLoadingAddToProject
  } = useQuery(
    "Add to my project",
    async () => {
      try {
        logEvent(eventsData.locale, eventsData.types.addToMyProject, eventsData.tags.startPage, id);
        const configurationFromApi = await getSavedConfigurationById({
          id,
          configurationType
        });
        const eventName = "ADD_TO_MY_PROJECT";

        var products = [];
        switch (configurationFromApi?.configuration?.configData?.configurationType) {
          case "MC12":
            const { track } = configurationFromApi?.configuration?.configData;
            products = gatherMc12ProductsForBOM(track);
            break;
          case "CARTESIAN":
            products = await gatherCartesianProductsForBOM(configurationFromApi?.configuration?.configId);
            break;
          case "INTEGRATED_DRIVES":
            products = [];
            break;
          default:
            const { axes } = configurationFromApi?.configuration?.configData;
            products = gatherRetrofitProductsForBOM(axes);
        }
        logDataLayerEvent(
          buildAddToCartDataLayerEvent(
            {
              id: configurationFromApi?.configuration?.configId,
              name: configurationFromApi?.configuration?.configData?.configName,
              step: "start"
            },
            eventName,
            products
          )
        );
        const res = await addToMyProject(configurationFromApi?.configuration);
        return res;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, id);
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const {
    refetch: execAddToCart,
    isFetching: isFetchingAddToMyCart,
    isLoading: isLoadingAddToMyCart
  } = useQuery(
    "Add to my cart",
    async () => {
      try {
        logEvent(eventsData.locale, eventsData.types.addToMyCart, eventsData.tags.startPage, id);
        const configurationFromApi = await getSavedConfigurationById({
          id,
          configurationType
        });
        const eventName = "ADD_TO_MY_CART";

        var products = [];
        switch (configurationFromApi?.configuration?.configData?.configurationType) {
          case "MC12":
            const { track } = configurationFromApi?.configuration?.configData;
            products = gatherMc12ProductsForBOM(track);
            break;
          case "CARTESIAN":
            products = await gatherCartesianProductsForBOM(configurationFromApi?.configuration?.configId);
            break;
          case "INTEGRATED_DRIVES":
            products = [];
            break;
          default:
            const { axes } = configurationFromApi?.configuration?.configData;
            products = gatherRetrofitProductsForBOM(axes);
        }
        logDataLayerEvent(
          buildAddToCartDataLayerEvent(
            {
              id: configurationFromApi?.configuration?.configId,
              name: configurationFromApi?.configuration?.configData?.configName,
              step: "start"
            },
            eventName,
            products
          )
        );
        const res = await addToMyCart(configurationFromApi?.configuration);
        return res;
      } catch (error) {
        dispatch(showSnackbar({ id: "ERROR" }));
        logEvent(eventsData.locale, eventsData.types.error, eventsData.tags.none, id);
        console.error("ERR", error.response?.status);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  const handleAddToMyProducts = () => {
    execAddToMyProducts();
  };

  const handleAddToMyProject = () => {
    execAddToProject();
  };

  const handleAddToMyCart = () => {
    execAddToCart();
  };

  const [isDuplicating, setIsDuplicating] = useState(false);

  const handleDuplicateConfiguration = () => {
    setIsDuplicating(true);
    execDuplicateConfiguration();
  };
  const menuItems = [
    {
      icon: <TiPencil />,
      label: t("msizer.ui.home.config_card.action.rename"),
      action: () => {
        setNewTitle(title);
        setShowEditName(true);
        setShowMenu(false);
      },
      menuTitle: "rename"
    },
    {
      icon:
        isLoadingExport || isFetchingExport ? <BiLoaderAlt className="animate-spin" /> : <HiOutlineDocumentDownload />,
      label:
        isLoadingExport || isFetchingExport
          ? t("msizer.ui.home.config_card.action.exporting")
          : t("msizer.ui.home.config_card.action.export"),
      action: () => {
        execExportXls();
      },
      menuTitle: "bill"
    },
    {
      icon:
        isLoadingAddToMyCart ||
        isFetchingAddToMyCart ||
        isLoadingAddToMyProducts ||
        isFetchingAddToMyProducts ||
        isFetchingAddToProject ||
        isLoadingAddToProject ? (
          <BiLoaderAlt className="animate-spin" />
        ) : (
          <AiOutlinePlusCircle />
        ),

      label:
        partnerPreferences?.addToCartAlias || isUnifiedCheckoutAvailable()
          ? t("msizer.ui.home.config_card.action.add_to_my_cart")
          : isWorkspaceAvailable()
            ? t("msizer.ui.home.config_card.action.add_to_my_project")
            : t("msizer.ui.home.config_card.action.add_to_my_products"),
      action: () => {
        if (isUnifiedCheckoutAvailable()) {
          handleAddToMyCart();
        } else if (isWorkspaceAvailable()) {
          handleAddToMyProject();
        } else {
          handleAddToMyProducts();
        }
        setShowMenu(false);
      },
      menuTitle: "product"
    },
    {
      icon:
        isFetchingDeleteConfiguration || isLoadingDeleteConfiguration ? (
          <BiLoaderAlt className="animate-spin" />
        ) : (
          <RiDeleteBin6Line />
        ),
      label:
        isFetchingDeleteConfiguration || isLoadingDeleteConfiguration
          ? t("msizer.ui.home.config_card.action.deleting")
          : t("msizer.ui.home.config_card.action.delete"),
      action: () => {
        // delete the configuration => change the status to OBSOLETE
        dispatch(setShowDeleteConfirmationPopup(true));
        getConfIdToDelete(id);
      },
      menuTitle: "delete"
    }
  ];

  const handleEditName = () => {
    execRenameConfiguration();
  };

  const closeWhenClickedOutsideTheMenu = (ref) => {
    useEffect(() => {
      /**
       * Close if clicked on outside of menu
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowMenu(false);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  function getLabelForConfigurationType(type) {
    switch (type) {
      case "RETROFIT":
        return t("msizer.ui.start-config-card-title");
      case "MC12":
        return t("mc12.ui.start-config-card-title");
      case "CARTESIAN":
        return t("cartesian.ui.start-config-card-title");
      case "INTEGRATED_DRIVES":
        return t("integrated_drives.ui.start-config-card-title");
      default:
        return type;
    }
  }

  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  closeWhenClickedOutsideTheMenu(buttonRef);

  useEffect(() => {
    if (showMenu) {
      // Get the width of the menu and the button
      const menuWidth = menuRef.current.offsetWidth;

      // Get the position of the button relative to the document
      const buttonRect = menuRef.current.getBoundingClientRect();
      const appWidth = document.querySelector(".motion-configurator-app").offsetWidth;

      // Calculate the left position of the menu
      let left = 0;
      if (buttonRect.left + menuWidth > appWidth) {
        left = menuWidth * -1 + 40;
      }

      // Set the left position of the menu
      menuRef.current.style.left = `${left}px`;
    }
  }, [showMenu]);

  const tooltipContent = `${t("msizer.ui.tooltip.corresponding_country_prefix")} ${country}. ${t(
    "msizer.ui.tooltip.corresponding_country_suffix"
  )}`;

  return (
    <>
      <div
        id={`start-card-config-${idLabel}`}
        className={`group shadow-lg rounded-lg bg-white p-3 pb-4 space-y-3 border-t-8 border-gray-100 transition-all duration-200 cursor-pointer select-none border-solid ${
          disabled
            ? "opacity-50 cursor-not-allowed"
            : "hover:border-t-primary hover:shadow-xl hover:-translate-y-2 hover:z-10"
        } ${isFetchingDeleteConfiguration || isLoadingDeleteConfiguration ? "animate-pulse" : ""}`}
        {...props}
      >
        <div className="top-part select-none flex items-start flex-wrap">
          <div className="top-left flex-1 flex flex-col space-y-1">
            <div className="text-gray-900 group-hover:text-black font-semibold flex">
              {showEditName && (
                <>
                  <input
                    id={`start-input-rename-config-${idLabel}`}
                    type="text"
                    pattern="^[^<>:/\\|?*\x00-\x1F]+$"
                    className="w-full border-gray-300 px-1 mr-2 rounded ring-1 ring-gray-200 py-1"
                    value={newTitle}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onChange={(e) => {
                      if (isFilenameValid(e.target.value)) {
                        setNewTitle(e.target.value);
                      }
                    }}
                    // on press enter => save the new name
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleEditName();
                      }
                    }}
                  />
                  <button
                    id={`start-button-rename-validate-${idLabel}`}
                    type="button"
                    className="bg-gray-10 mr-2 hover:bg-lightGreen hover:text-white transition-all shadow ring-1 ring-gray-100 duration-100 text-primary px-1 rounded"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditName();
                    }}
                  >
                    {isFetchingRenameConfiguration || isLoadingRenameConfiguration ? (
                      <BiLoaderAlt className="animate-spin" />
                    ) : (
                      <GoCheck />
                    )}
                  </button>
                  <button
                    type="button"
                    className="bg-gray-10 hover:bg-gray-100 transition-all shadow ring-1 ring-gray-100 border-[1px] duration-100 px-1 rounded"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowEditName(false);
                    }}
                  >
                    <MdOutlineCancel />
                  </button>
                </>
              )}
              {!showEditName && (
                <div className="space-y-1">
                  <span
                    title={title}
                    className="font-bold text-lg whitespace-nowrap overflow-hidden text-ellipsis max-w-[200px] block
                  "
                  >
                    {title}
                  </span>
                  <span className={`hidden font-normal text-xs w-fit text-gray-700 rounded-lg ${statusStyle[status]}`}>
                    ({status.replace("_", " ")})
                  </span>
                </div>
              )}
            </div>
            <span className=" text-sm text-gray-600">{moment(date).format("MMM DD, YYYY")}</span>
          </div>
          {!showEditName && (
            <div className="top-right mt-2 flex items-center justify-center space-x-2">
              <img
                className="h-5"
                src={`${process.env.REACT_APP_STATIC_FILES_URL || process.env.PUBLIC_URL}/flags/${country}.svg`}
                alt={country}
              />
              <span className=" text-xs text-gray-500">{country}</span>
              <MsxIcons
                data-tip={tooltipContent}
                data-for={`countryScopeInfo-${id}`}
                name="info"
                size="nano"
                className="text-gray-400"
                onClick={(e) => e.stopPropagation()}
              />
              <ReactTooltip
                id={`countryScopeInfo-${id}`}
                type="light"
                effect="solid"
                backgroundColor="#FFFFFF"
                textColor="rgb(31 41 55)"
                className="hover:visible shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
                html
              />
            </div>
          )}
        </div>
        <div className="middle-part text-xs h-5">
          {configurationType === "RETROFIT" && (
            <span className="bg-gray-100  p-[0.25rem] w-fit px-3 rounded-l-sm rounded-r-xl">
              {numberOfAxes === 1 ? `1 ${t("msizer.ui.axis")}` : `${numberOfAxes} ${t("msizer.ui.axes")}`}
            </span>
          )}
          {configurationType === "CARTESIAN" && (
            <span className="bg-gray-100  p-[0.25rem] w-fit px-3 rounded-l-sm rounded-r-xl">
              {kinematicsType || "No type found"}
            </span>
          )}
        </div>
        <div className="bottom-part flex items-center text-gray-700">
          <div className="bottom-left flex-1 flex flex-col space-y-2 text-xs">
            <div className="flex items-center space-x-1">
              <img className="h-4" src={favicon} alt="SE" />
              <span className=" text-gray-400 font-semibold">{getLabelForConfigurationType(configurationType)}</span>
            </div>
          </div>
          <div className="bottom-right flex text-sm">
            {countryScope !== "CN" && (
              <span
                id={`start-button-share-${idLabel}`}
                title={t("msizer.ui.tooltip.share_configuration")}
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setConfigurationIdToShare(id));
                  dispatch(setConfigurationTypeToShare(configurationType));
                  dispatch(setShowEmailPopup(true));
                }}
                className="px-2 py-1 hover:bg-gray-50 rounded"
              >
                <MsxIcons name="share" size="small" />
              </span>
            )}

            <span
              id={`start-button-duplicate-${idLabel}`}
              title={t("msizer.ui.tooltip.duplicate_configuration")}
              onClick={(e) => {
                e.stopPropagation();
                if (!isDuplicating) {
                  handleDuplicateConfiguration();
                }
              }}
              className="px-2 py-1 hover:bg-gray-50 rounded"
            >
              {isDuplicating && <BiLoaderAlt className="animate-spin" />}
              {!isDuplicating && <MsxIcons name="duplicate" size="small" />}
            </span>

            <div
              id={`start-button-more-${idLabel}`}
              className="px-2 py-1 relative hover:bg-gray-50 rounded"
              ref={buttonRef}
              onClick={(e) => {
                e.stopPropagation();
                setShowMenu(!showMenu);
              }}
            >
              <MsxIcons name="other" size="small" />

              {showMenu && (
                <div
                  ref={menuRef}
                  className="absolute select-none md:left-0 -left-24 w-44 rounded-sm shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-20"
                >
                  <div>
                    {menuItems.map(({ icon, label, action, menuTitle }) => (
                      <div
                        id={`start-button-${menuTitle}-${idLabel}`}
                        key={label}
                        onClick={(e) => {
                          action();
                          e.stopPropagation();
                        }}
                        className="flex items-center space-x-2 text-gray-500 p-2 hover:bg-gray-50"
                      >
                        {icon}
                        <span className=" text-xs">{label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SavedConfigCard;

SavedConfigCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.number.isRequired,
  country: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  numberOfAxes: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  configurationType: PropTypes.string.isRequired,
  getConfIdToDelete: PropTypes.func.isRequired,
  idLabel: PropTypes.string.isRequired,
  kinematicsType: PropTypes.string,
  configuration: PropTypes.object.isRequired
};

SavedConfigCard.defaultProps = {
  kinematicsType: ""
};
